import React, { useState } from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';
import { alertTypeOptions, alertStatusOptions } from '../../utils';

const CombinedAlertDropdown = ({ state, updateState, clearSelection }) => {
  const [open, setOpen] = useState(false);
  const [expandedType, setExpandedType] = useState(null);

  const handleTypeChange = (type) => {
    if (type === "") {
      updateState({ 
        chosenAlertType: "", 
        chosenAlertStatus: "" 
      });
    } else {
      updateState({ 
        chosenAlertType: type,
        chosenAlertStatus: state.chosenAlertStatus === '' ? "all" : state.chosenAlertStatus
      });
    }
  };

  const handleStatusChange = (type, status) => {
    updateState({
      chosenAlertType: type,
      chosenAlertStatus: state.chosenAlertStatus === status ? "all" : status
    });
  };

  const toggleExpand = (type, e) => {
    e.stopPropagation();
    setExpandedType(expandedType === type ? null : type);
  };

  const getDisplayText = () => {
    if (state.chosenAlertType === "") return "All Students";
    
    const typeLabel = alertTypeOptions.find(o => o.value === state.chosenAlertType)?.label;
    
    if (state.chosenAlertStatus === "all") return typeLabel;
    
    const statusLabel = alertStatusOptions
      .find(o => o.value === state.chosenAlertStatus)?.label;
    
    return `${typeLabel}: ${statusLabel}`;
  };

  return (
    <div className="relative w-full">
      {!open ? (
        <div
          className="justify-between rounded p-1.5 border border-[#DDDDDD] w-full h-full flex items-center cursor-pointer bg-white"
          onClick={() => setOpen(true)}
        >
          <span className="flex items-center bg-blue-100 text-[#2763D4] text-[14px] px-2 py-1 rounded-full">
            {getDisplayText()}
            {(state.chosenAlertType !== "" || state.chosenAlertStatus !== "") && (
              <button 
                onClick={clearSelection} 
                className="ml-2 text-[#2763D4]"
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </span>
          <svg
              className="w-3 h-3 text-gray-600 cursor-pointer mr-2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 10 6"
              fill="currentColor"
            >
              <path d="M0 0l5 6 5-6H0z" />
            </svg>
        </div>
      ) : (
        <div className="bg-white border border-[#DDDDDD] rounded p-3 z-10 w-full">
          <div className="flex items-center justify-between">
            <span className="text-[14px] font-medium">Filter Students by Alerts</span>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
              className="text-gray-600 hover:text-gray-800"
            >
              <X className="w-3 h-3 mr-2" />
            </button>
          </div>
          
          {/* All Students Option */}
          <div 
            className="flex items-center py-1 hover:bg-gray-100 cursor-pointer"
            onClick={() => handleTypeChange("")}
          >
            <input
              type="checkbox"
              checked={state.chosenAlertType === ""}
              readOnly
              className="mr-2 w-4 h-4 border border-1 rounded"
              style={{
                backgroundColor: state.chosenAlertType === ""
                ? "#2763D4"
                : "transparent",
              }}
            />
            <span className="text-[14px]">All Students</span>
          </div>
          
          {/* Alert Type Options */}
          {alertTypeOptions.map((typeOption) => (
            <div key={typeOption.value} className="mb-1">
              <div 
                className="flex items-center justify-between py-1 hover:bg-gray-100 cursor-pointer"
                onClick={(e) => {
                  if (e.target.tagName !== 'INPUT') {
                    handleTypeChange(typeOption.value);
                    toggleExpand(typeOption.value, e)
                  }
                }}
              >
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={state.chosenAlertType === typeOption.value}
                    onChange={() => handleTypeChange(typeOption.value)}
                    className="mr-2 w-4 h-4 border border-1 rounded"
                    style={{
                      backgroundColor: state.chosenAlertType === typeOption.value
                      ? "#2763D4"
                      : "transparent",
                    }}
                  />
                  <span className="text-[14px]">{typeOption.label}</span>
                </div>
                <button 
                  onClick={(e) => toggleExpand(typeOption.value, e)}
                  className="p-1 text-gray-600 hover:bg-gray-200 rounded"
                >
                  {expandedType === typeOption.value ?
                    <ChevronUp className="w-3 h-3 text-gray-600 mr-2" /> : 
                    <ChevronDown className="w-3 h-3 text-gray-600 mr-2" />
                  }
                </button>
              </div>
              
              {/* Status Suboptions */}
              {expandedType === typeOption.value && (
                <div className="ml-5 pl-1">
                  {alertStatusOptions
                    .filter(opt => opt.value !== "all")
                    .map((statusOption) => (
                      <div
                        key={statusOption.value}
                        className="flex items-center py-1 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleStatusChange(typeOption.value, statusOption.value)}
                      >
                        <input
                          type="checkbox"
                          checked={
                            state.chosenAlertType === typeOption.value && 
                            state.chosenAlertStatus === statusOption.value
                          }
                          readOnly
                          className="mr-2 w-4 h-4 border border-1 rounded"
                          style={{
                            backgroundColor: state.chosenAlertType === typeOption.value && state.chosenAlertStatus === statusOption.value
                            ? "#2763D4"
                            : "transparent",
                          }}
                        />
                        <span className="text-[14px]">{statusOption.label}</span>
                      </div>
                    ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CombinedAlertDropdown;